import axios from 'axios';

// Ensure axios sends cookies with all requests by default
axios.defaults.withCredentials = true;

// Global response interceptor to handle 401 authentication errors
axios.interceptors.response.use(
  response => response, // Pass through successful responses
  error => {
    // Handle 401 Unauthorized errors (session expired)
    if (error.response?.status === 401) {
      console.warn('[AUTH] 401 Unauthorized - Session expired. Redirecting to login...');
      
      // Save current location to return after login
      const returnTo = window.location.pathname + window.location.search;
      
      // Redirect to Google auth with return URL
      window.location.href = `/auth/google?returnTo=${encodeURIComponent(returnTo)}`;
      
      // Return a resolved promise to prevent further error handling
      return new Promise(() => {}); // Never resolves, page is redirecting
    }
    
    // Pass through other errors for component-level handling
    return Promise.reject(error);
  }
);

export default axios;
